export default {
  name: 'Name',
  email: 'Email',
  password: 'Password',
  whatsApp: 'WhatsApp',
  commission: 'Commission',
  idNumber: 'ID Number',
  consumer: 'Consumer',
  provider: 'Provider',
  views: 'Views',
  add: 'Add',
  create: 'Create',
  downloadExcel: 'Download Excel',
  edit: 'Edit',
  delete: 'Delete',
  price: 'Price',
  created: 'Created',
  updated: 'Updated',
  status: 'Status',
  title: 'Title',
  date: 'Date',
  cancel: 'Cancel',
  save: 'Save',
  apply: 'Apply',
  download: 'Download',
  from: 'From',
  to: 'to',
  pickDay: 'Pick a day',
  site: {
    name: 'ToDoServy',
    slogan: 'Community of Professionals'
  },
  pages: {
    dashboard: 'Dashboard',
    payed: 'Payment list',
    specialities: 'Specialities',
    serviceTypes: 'Service Types',
    industries: 'Service Industries',
    invoice: 'Invoice',
    users: 'Customers',
    hunters: 'Hunters',
    providers: 'Service Providers',
    invoices: 'Generate invoices',
    coupons: 'Discount & Coupons'
  },
  auth: {
    logIn: 'Log In',
    errors: {
      email: 'Please input the email',
      password: 'Please input the password'
    }
  },
  statistics: {
    totalSales: '<strong>Total</strong><br>Sales',
    sessionsCanceled: '<strong>Sessions</strong><br>canceled',
    sessionsBooked: '<strong>Total</strong><br>Sessions booked',
    sessionsConfirmed: '<strong>Sessions</strong><br>confirmed by Clients',
    providersProfileViews: '<strong>Service Providers</strong><br>profile views'
  },
  hunters: {
    title: 'Hunter',
    delegate: 'Delegate a Hunter',
    select: 'Select a hunter'
  },
  providers: {
    search: 'Search Service Providers',
    signed: 'Signed up on',
    export: 'Export to Excel'
  },
  invoices: {
    export: 'Export Invoice'
  },
  payed: {
    consumer: 'Consumer',
    documentType: 'Document type',
    document: 'Document',
    professional: 'Professional',
    amount: 'Payed amount',
    transactionDate: 'Transaction date',
    paymentType: 'Payment type',
    service: 'Service',
    dateAndTime: 'Date and time',
    transactionAmount: 'Transaction amount',
    payedWith: 'Payed with',
    client: 'Client'
  },
  addIndustry: 'Add Service Industry',
  editIndustry: 'Edit Service Industry',
  deleteServiceIndustry: 'Are you sure you want to delete this Service Industry?',
  deleteServiceTypes: 'Are you sure you want to delete this Service Type?',
  deleteSpeciality: 'Are you sure you want to delete this Service speciality?'
}
